'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'chevrons-up';
var width = 448;
var height = 512;
var aliases = ["chevron-double-up"];
var unicode = 'f325';
var svgPathData = 'M235.4 36.7l-11.3-11.3-11.3 11.3-208 208-11.3 11.3 22.6 22.6 11.3-11.3 196.7-196.7 196.7 196.7 11.3 11.3 22.6-22.6-11.3-11.3-208-208zm0 192l-11.3-11.3-11.3 11.3-208 208-11.3 11.3 22.6 22.6 11.3-11.3 196.7-196.7 196.7 196.7 11.3 11.3 22.6-22.6-11.3-11.3-208-208z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;